export default __webpack_public_path__ + "static/media/reperence2.721e1e69.jpg";